var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo, hasMany } from '@ember-data/model';
import { isEmpty } from '@ember/utils';
import { fragment, fragmentArray, array } from 'ember-data-model-fragments/attributes';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { CheckoutLinkType as CheckoutLinkTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
const DEFAULT_CHECKOUT_LINK_SOURCE = 'DASHBOARD';
export let SOURCE = /*#__PURE__*/function (SOURCE) {
  SOURCE["CATALOG"] = "CATALOG";
  SOURCE["ONLINE_CHECKOUT"] = "ONLINE_CHECKOUT";
  return SOURCE;
}({});
export function getSource(source) {
  const prefix = DEFAULT_CHECKOUT_LINK_SOURCE;
  return !isEmpty(source) ? `${prefix}.${source}` : prefix;
}

// https://prototype.sqprod.co/#/docs/squareup.connect.v2.merchant_catalog.resources.CatalogCheckoutLink
let Data = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('boolean'), _dec4 = attr('string', {
  protoEnum: CheckoutLinkTypeProto
}), _dec5 = belongsTo('connect/checkout-link/order-details', {
  async: false
}), _dec6 = fragment('connect/checkout-link/checkout-button'), _dec7 = hasMany('connect/subscription-plan', {
  async: false
}), _dec8 = array(), _dec9 = fragment('connect/checkout-link/donation-goal'), _dec10 = attr('boolean'), _dec11 = attr('boolean'), _dec12 = attr('string'), _dec13 = fragmentArray('connect/checkout-link/custom-field'), _dec14 = array(), _dec15 = attr('string'), _dec16 = attr('string'), _dec17 = attr('string'), _dec18 = attr('string'), _dec19 = attr('string', {
  defaultValue: DEFAULT_CHECKOUT_LINK_SOURCE
}), _class = (_class2 = class Data extends EmberDataBaseModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "description", _descriptor2, this);
    _initializerDefineProperty(this, "enabled", _descriptor3, this);
    _initializerDefineProperty(this, "linkType", _descriptor4, this);
    _initializerDefineProperty(this, "orderDetails", _descriptor5, this);
    _initializerDefineProperty(this, "checkoutButton", _descriptor6, this);
    _initializerDefineProperty(this, "subscriptionPlans", _descriptor7, this);
    _initializerDefineProperty(this, "subscriptionPlanIds", _descriptor8, this);
    _initializerDefineProperty(this, "donationGoal", _descriptor9, this);
    _initializerDefineProperty(this, "allowTipping", _descriptor10, this);
    _initializerDefineProperty(this, "subscriptionOnly", _descriptor11, this);
    _initializerDefineProperty(this, "redirectUrl", _descriptor12, this);
    _initializerDefineProperty(this, "customFields", _descriptor13, this);
    _initializerDefineProperty(this, "imageIds", _descriptor14, this);
    /**
     * The short url field must be present, otherwise dashboard will remove the
     * field when saving the checkout link.
     */
    _initializerDefineProperty(this, "shortUrl", _descriptor15, this);
    _initializerDefineProperty(this, "longUrl", _descriptor16, this);
    _initializerDefineProperty(this, "url", _descriptor17, this);
    /*
     * We are not using this field in dashboard, but to ensure it is always returned with the model,
     * we include it.
     */
    _initializerDefineProperty(this, "referenceId", _descriptor18, this);
    /*
     * This value is set for models created on dashboard, but not others. Others will all have a value,
     * (e.g. 'dashboard',  'spos', 'external api')
     */
    _initializerDefineProperty(this, "source", _descriptor19, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/checkout-link/data'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "enabled", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "linkType", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "orderDetails", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "checkoutButton", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "subscriptionPlans", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "subscriptionPlanIds", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "donationGoal", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "allowTipping", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "subscriptionOnly", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "redirectUrl", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "customFields", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "imageIds", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "shortUrl", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "longUrl", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "url", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "referenceId", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "source", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };